import commonMapping from "@/mapping/common";

const mul_session_type_list = [
  { id: "session1", value: "session1", config: "session1", label: "mul_session1" },
  { id: "session2", value: "session2", config: "session2", label: "mul_session2" },
];

const mode_list = [
  { id: "skeyword_never", value: "never", config: "never", label: "never_mark" },
  { id: "skeyword_sched", value: "perschedule", config: "schedule", label: "per_schedule_mark" },
  { id: "skeyword_always", value: "always", label: "always_mark", config: "always" },
];

export const blockSites = {
  mul_session_type: mul_session_type_list,
  trust_ip_enble: commonMapping.intToBoolean,
  mode: mode_list,
};

export default blockSites;
